import { push } from 'redux-first-history';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import { SingleInput } from '@imprivata/nucleus';
import headerImage from '../../images/email.svg';
import { EmailProtocols } from '../../constants/clientProtocols';
import LogoutStyled from '../shared/LogoutStyled';
import MoreOptions from '../shared/MoreOptions';
import RememberMe from '../shared/RememberMe';

/**
 * Email Component
 */
export class Email extends Component {
  state = {
    tokenCode: '',
    emailAddresses: ['your email',],
  };
  /**
   * The allowed properties for the Email component
   * @param {function} verifyEmail verification the token code
   * @param {bool} isLoading is something on the page loading?
   * @param {array} availableModalities available modalities to switch to
   */
  static propTypes = {
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    isLoading: PropTypes.bool,
    verifyEmail: PropTypes.func.isRequired,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
  };
  static defaultProps = {
    availableModalities: [],
    authenticatedModalities: [],
    useCustomUX: false,
  };


  constructor(props) {
    super(props);

    let modalities;
    (this.props.serverState && this.props.serverState.modalities) && (modalities = this.props.serverState.modalities);

    if (modalities !== undefined) {
      const authState = EmailProtocols.EmailAuthState.getValue(modalities.optionalEmailOtpAuthenticationState);
      /* istanbul ignore next */
      if (authState !== null &&
        authState.emailAddresses !== undefined &&
        authState.emailAddresses.length > 0) {
        this.state.emailAddresses = authState.emailAddresses;
      }
    }
  }

  resendEmail = () => {
    this.props.resendEmail();
  };

  submitForm = data => {
    this.props.verifyEmail(data.tokenCode);
    this.setState({ tokenCode: '', });
  };

  handleInputChange = (data) => {
    this.setState({ tokenCode: data.tokenCode, });
  };

  render() {
    const {
      availableModalities,
      serverState,
      useCustomUX,
      username,
      allowEditUsername,
    } = this.props;

    let moreOptions = null;
    let moreOptionsMarkup = <MoreOptions currentModality='email' />;
    let moreOptionsAltMarkup = <div className='Temp-code-text'>Alternatively, call your help desk for a temp code</div>;

    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'email') : [];
    const modalitiesArePresent = modalities.length > 0;

    const hasTempCodeMessage = serverState && serverState.temporaryCodeAllowed && !serverState.temporaryCodeAvailable;

    modalitiesArePresent && (moreOptions = moreOptionsMarkup);
    (hasTempCodeMessage && !modalitiesArePresent) && (moreOptions = moreOptionsAltMarkup);

    const partialEmail = this.state.emailAddresses[0];

    const logoutStyle = useCustomUX ? 'black' : 'white';

    return (
      <div className='content-body'>
        <SingleInput
          headerImage={headerImage}
          headerTitle='Check your email'
          headerDescription={<p>Code sent to <strong>{partialEmail}</strong></p>}
          placeholderText='Email code'
          submitText='Enter'
          onSubmit={this.submitForm}
          retryText="Didn't get a code?"
          onRetryClick={this.resendEmail}
          inputType='text'
          maxLength='6'
          isLoading={this.props.isLoading}
          autoFocus={true}
          moreOptionsLink={moreOptions}
          onInputChange={data => this.handleInputChange(data)}
          tokenCode={this.state.tokenCode}
          logoutComponent={<LogoutStyled type={logoutStyle} />}
          footer={<RememberMe />}
          useCustomUX={useCustomUX}
          username={username}
          allowEditUsername={allowEditUsername}
          resetUsername={this.props.reset}
        />
      </div>
    );
  }
}


const mapStateToProps = state => {
  const {
    isLoading, availableModalities, serverState, isDeviceManagementWorkflow, partialEmail, useCustomUX,
    username, isClinicalWorkflow, allowEditUsername,
  } = state.login;
  return {
    isLoading,
    availableModalities,
    serverState,
    isDeviceManagementWorkflow,
    partialEmail,
    useCustomUX,
    username,
    allowEditUsername,
    isClinicalWorkflow,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    verifyEmail: tokenCode => {
      dispatch(actions.verifyEmail(tokenCode) );
    },
    resendEmail: () => {
      dispatch(actions.resendEmail() );
    },
    returnToChooseModality: () => {
      dispatch(actions.startIgnoreTimeout() );
      dispatch(actions.moreOptionsChooseModality(false) );
      dispatch(push('/choosemodality') );
    },
    reset: () => {
      dispatch(actions.reset() );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Email);
